import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDClickableText,
  FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { GuidedHouseholdReviewSections } from 'Components/UI/guidedHouseholdReview/sections';
import { metaOverrideSet } from 'Views/Page/Content/Templates/guidedHouseholdReviewCashFlowPageTemplate/metaOverrideSet';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import LoadingIndicator from 'Components/UI/LoadingIndicator';


const MathSection = ({ onHideButtonClick }) => {
  const { resource } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();
  const [assumptionsLoading, setAssumptionsLoading] = useState(false);

  const handleAssumptionsClick = async (rel) => {
    setAssumptionsLoading(true);
    try {
      await loadModalCollectionByLink(rel.link('related').url());
    } finally {
      setAssumptionsLoading(false);
    }
  };

  return (
    <FDStack direction={'column'} spacing={3} paddingX={3} paddingY={5} {...dataAttrs('roadmap-goals-math-section')}>
      <MetaControlField attr={'title'} />
      <GuidedHouseholdReviewSections metaOverrideSet={metaOverrideSet} collection={resource.attr('sections')} outlined={false} />
      <FDStack direction="row" justifyContent={'space-between'}>
        <FDSecondaryActionButton
          size={'sm'}
          label={'Hide the math'}
          onClick={onHideButtonClick}
        />
        <FDStack direction={'row'} justifyContent={'center'} alignItems={'center'} width={200}>
          {resource.withRelationship(fr.relationships.assumptions.name,
            (rel) => (assumptionsLoading ? <LoadingIndicator spacing={false} size={20} /> : (
              <FDClickableText
                appearance={'standalone'}
                label={rel.meta('prompt')}
                onClick={() => handleAssumptionsClick(rel)}
              />
            )
            ),
            () => null)}
        </FDStack>
      </FDStack>
    </FDStack>
  );
};

MathSection.defaultProps = {
};

MathSection.propTypes = {
  onHideButtonClick: PropTypes.func.isRequired,
};

export default MathSection;
